import { createSelector } from 'reselect';

import type { State } from '@wetransfer/transfer/store/types';

import {
  PaymentIntegrationsState,
  ProviderStripeStatus,
  StripeState,
} from './types';

const selectPaymentIntegrationsSlice = (
  state: State
): PaymentIntegrationsState => state.paymentIntegrations;

const selectStripeState = createSelector(
  selectPaymentIntegrationsSlice,
  ({ stripe }: PaymentIntegrationsState): StripeState => stripe
);

export const selectStripeStatus = createSelector(
  selectStripeState,
  ({ status }: StripeState): ProviderStripeStatus => status
);

export const selectStripeAccountEmail = createSelector(
  selectStripeState,
  ({ accountEmail }: StripeState): string | null => accountEmail
);
